module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n5n9r3r-d0293ee9a88a5913a79c65a5ae73032a.svg";